import { rei } from "@/services/api"

class ProtocolosLogService {
  static store (log) {
    const payload = {
      observacao: log.observacao,
      protocolo_id: log.protocolo_id
    }

    return rei.post(`/protocolos/${ log.protocolo_id }/logs`, payload).then(res => res.data)
  }

  static update (id, log) {
    const payload = {
      observacao: log.observacao,
      id: log.id,
      protocolo_id: log.protocolo_id
    }

    return rei.put(`/protocolos/${ log.protocolo_id }/logs/${ id }`, payload).then(res => res.data)
  }

  static delete (log) {
    const payload = {
      id: log.id,
      protocolo_id: log.protocolo_id
    }

    return rei.delete(`/protocolos/${ log.protocolo_id }/logs/${ log.id }`, payload).then(res => res.data)
  }
}

export default ProtocolosLogService
